/**
 * Estado mínimo del alta en dos fases. La comunidad se persiste una sola vez;
 * si después falla un documento, el siguiente intento reutiliza su id.
 */
export const createCommunityRecoveryState = () => ({
  propertyId: null,
  uploadedSlots: new Set(),
})

export const ensureCommunityCreated = async (state, payload, createProperty) => {
  if (state.propertyId) return state.propertyId

  const response = await createProperty(payload)
  const propertyId = response?.data?.value?.id
  if (!propertyId) throw new Error('Community creation did not return an id')
  state.propertyId = propertyId
  return propertyId
}

/**
 * Sube solo los documentos todavía pendientes. Cada subida confirmada se
 * recuerda antes de continuar, de modo que un fallo posterior no la repite.
 */
export const uploadPendingCommunityFiles = async ({
  state,
  propertyId,
  files,
  slots,
  isUploadable,
  upload,
}) => {
  for (const slot of slots) {
    const file = files[slot]
    if (!isUploadable(file) || state.uploadedSlots.has(slot)) continue
    await upload(propertyId, slot, file)
    state.uploadedSlots.add(slot)
  }
}
